import RewardsTabs from './Components/RewardTab';
import { REWARD_TABS } from './utils';
const MyNetwork = () => (
  <RewardsTabs allowedTabs={[REWARD_TABS['NETWORK_INFLUENCER'], REWARD_TABS['NETWORK'] ]} />
);
export default MyNetwork;
